import { useEffect, useState } from "react"
import { useProjetosService } from "../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../hooks/store-hooks"
import { SkeletonGeoVelesList } from "../../../../../components"
import { Avatar, Box, Button, Card, CardActions, CardContent, Divider, Grid, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Typography } from "@mui/material"
import { format } from "date-fns"
import { theme } from "../../../../../styles"
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';

export const ProjetosRecentes = () => {
    // State
    const { projetos } = useAppSelector((state) => state.projetos)
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    // Hook
    const { openProjeto, setProjetosPaginaInicial, setOpenCreateProjetoForm } = useProjetosService()
    // UseEffect
    useEffect(() => {
        setLoading(false)
    }, [])

    useEffect(() => {
        setProjetosPaginaInicial()
    }, [setProjetosPaginaInicial])

    return (
        <>
            <Grid container p={2}>
                <Grid item xs={12} display={'flex'} mx={5}>
                    {
                        loading ?
                            <SkeletonGeoVelesList />
                            : projetos.length > 0 ?
                                <>
                                    <List sx={{ width: '100%' }}>
                                        {
                                            projetos.map((projeto, index) => (
                                                <Box key={index}>
                                                    <ListItem
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar sx={{ background: theme.palette.primary.main }}>
                                                                <img
                                                                    src="/logo_geo_veles.png"
                                                                    alt="P"
                                                                    style={{
                                                                        width: '80%',
                                                                        height: 'auto',
                                                                        filter: 'brightness(0) invert(1)',
                                                                    }}
                                                                />
                                                            </Avatar>
                                                        </ListItemAvatar>

                                                        {/* Nome do projeto */}
                                                        <ListItemText
                                                            primary={projeto.Nome}
                                                            secondary={`Criado em: ${format(new Date(projeto.Inclusao), 'dd/MM/yyyy')}`}
                                                            sx={{
                                                                flex: 1, // Faz o texto ocupar o espaço restante
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                marginRight: '16px', // Espaço entre o texto e o botão
                                                            }}
                                                            primaryTypographyProps={{
                                                                fontSize: '0.900rem',
                                                            }}
                                                        />

                                                        {/* Botão "Abrir projeto" */}
                                                        <Box
                                                            sx={{
                                                                width: '150px', // Largura fixa do botão
                                                                textAlign: 'right',
                                                            }}
                                                        >
                                                            <ListItemButton onClick={() => openProjeto(projeto.IdVelesGeoProjeto)}>
                                                                <Typography
                                                                    variant="caption"
                                                                    color="primary"
                                                                    textTransform="uppercase"
                                                                    fontWeight="bold"
                                                                >
                                                                    Abrir projeto
                                                                    <KeyboardTabIcon sx={{ ml: 1 }} />
                                                                </Typography>
                                                            </ListItemButton>
                                                        </Box>
                                                    </ListItem>
                                                    <Divider color={theme.palette.primary.main} />
                                                </Box>
                                            ))
                                        }
                                    </List>
                                </>
                                : <>
                                    <Paper
                                        elevation={6}
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            width: '80%',
                                            mx: 'auto'
                                        }}
                                    >
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textAlign: 'center',
                                                width: '100%',
                                                margin: '0 auto'
                                            }}
                                        >
                                            <CardContent>
                                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                                    Parece que você ainda não criou nenhum projeto.
                                                </Typography>
                                                <Typography color="text.secondary">
                                                    Clique no botão abaixo e comece uma nova busca.
                                                </Typography>
                                                <Divider
                                                    variant="middle"
                                                    sx={{ mt: 2 }}
                                                    color={theme.palette.primary.main}
                                                />
                                            </CardContent>
                                            <CardActions>
                                                <Button
                                                    size="small"
                                                    onClick={() => setOpenCreateProjetoForm(true)}
                                                    sx={{
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    Criar Projeto
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Paper>
                                </>
                    }
                </Grid>
            </Grid>
        </>
    )
}